module.exports = __webpack_public_path__ + "static/media/wip-white.a161ef98.svg";